import { Platform } from 'react-native';

import { IRestaurant } from '@rbi-ctg/store';
import { IPhysicalAddress } from 'generated/graphql-gateway';

export const STORE_UNAVAILABLE = 'STORE_UNAVAILABLE';

export const DAYPART_FORMAT = 'HH:mm';
export const PARSE_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSSSSSS';
export const ALT_PARSE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const LOCALE_TIME_PARSE_FORMAT = 'HH:mm:ss';
export const TWELVE_HOUR_TIME_PARSE_FORMAT = 'h:mm aaaa';
export const SIMPLIFIED_TWELVE_HOUR_TIME_PARSE_FORMAT = 'h:mmaaa';
export const DAY_HOUR_TIME_PARSE_FORMAT = 'MMM, dd h:mm aaaa';
export const MIDNIGHT = '12:00 a.m.';

export const STATE_MAP = {
  Alabama: 'AL',
  Alaska: 'AK',
  'American Samoa': 'AS',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District Of Columbia': 'DC',
  'Federated States Of Micronesia': 'FM',
  Florida: 'FL',
  Georgia: 'GA',
  Guam: 'GU',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  'Marshall Islands': 'MH',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  'Northern Mariana Islands': 'MP',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Palau: 'PW',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  'Virgin Islands': 'VI',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
}

export const DEFAULT_STORE_TIMEZONE = 'America/New_York';
export const DEFAULT_SEARCH_RADIUS_IN_METERS = 8000;
export const DISABLE_STORE_CHANGE_DIALOG = false;

export const DEFAULT_MAP_ZOOM = Platform.select({
  ios: 21500,
  default: 12,
});

// Zoom level for static maps showing a single location (e.g., order confirmation)
export const STATIC_MAP_ZOOM = 13.5;

export const defaultInitialZoom = Platform.select({
  ios: 12,
  android: 3,
  default: 3.4,
});

export const defaultFocusZoom = Platform.select({
  ios: 6000,
  android: 14,
  default: 12,
});

export const initialStoreState: IRestaurant = {
  _id: null,
  isNonTraditional: false,
  accessInstructions: '',
  chaseMerchantId: '',
  deliveryHours: null,
  diningRoomHours: null,
  distanceInMiles: null,
  drinkStationType: null,
  driveThruHours: null,
  mobileOrderDriveThruHours: null,
  driveThruLaneType: null,
  email: null,
  environment: null,
  fastestServiceMode: null,
  franchiseGroupId: null,
  franchiseGroupName: null,
  frontCounterClosed: null,
  hasBreakfast: null,
  hasBurgersForBreakfast: null,
  hasDelivery: null,
  hasDineIn: null,
  hasDriveThru: null,
  hasMobileOrderDriveThru: null,
  hasMobileOrdering: null,
  hasParking: null,
  hasPlayground: null,
  hasTakeOut: null,
  hasWifi: null,
  hasLoyalty: null,
  isDarkKitchen: null,
  isHalal: null,
  isOrderEtaEnabled: false,
  latitude: null,
  longitude: null,
  mobileOrderingStatus: null,
  name: null,
  number: null,
  orderEtaValue: null,
  parkingType: null,
  phoneNumber: null,
  physicalAddress: {} as IPhysicalAddress,
  playgroundType: null,
  pos: null,
  posRestaurantId: null,
  restaurantImage: null,
  restaurantPosData: null,
  status: null,
  amenities: [],
  vatNumber: null,
  available: false,
  isAvailable: false,
  isFavorite: false,
  isRecent: false,
  localTime: null,
  serviceModeHours: null,
  dayPartHours: null,
  isOpenByServiceMode: null,
  isOneMenu: false,
};

export const LOG_MESSAGE_STORE_CHANGE_ERROR = 'Store error while selecting store';

export const hasShownStoreChangeDialog = { current: false };
